// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/InclusiveSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/InclusiveSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/InclusiveSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/InclusiveSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/icons/search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/icons/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/icons/chevron-up.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/icons/arrow-up.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/icons/arrow-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts */

@font-face {
  font-family: "Inclusive Sans";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Inclusive Sans";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

/*
  Josh's Custom CSS Reset
  https://www.joshwcomeau.com/css/custom-css-reset/
*/

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
}

@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

input,
button,
textarea,
select {
  font: inherit;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

#root,
#__next {
  isolation: isolate;
}

/* Weather App */

:root {
  --gray-100: #f5f5f5;
  --gray-400: #bdbdbd;
  --gray-900: #212121;
  --white: #fff;
}

body {
  font-family:
    Inclusive Sans,
    Arial,
    Helvetica,
    sans-serif;
  color: var(--gray-900);
  background-color: var(--gray-100);
}

/* Overlay and Spinner */

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: none;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(5px);
}

.spinner {
  width: 150px;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background-color: var(--white);
  border-radius: 10px;
}

.spinner-icon {
  width: 50px;
  height: 50px;
  border: 5px solid var(--gray-100);
  border-top: 5px solid var(--gray-400);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

.spinner-text {
  font-weight: bold;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Header */

header {
  display: flex;
  justify-content: center;
  background-color: var(--white);
  border-bottom: 2px solid var(--gray-400);

  width: 100%;
}

header .container {
  display: flex;
  align-items: center;
  gap: 20px;
  width: 960px;
  max-width: 100vw;
  padding: 10px 20px;
}

h1 {
  display: flex;
  align-items: center;
  gap: 10px;
  line-height: 1;
}

h1 img {
  width: 40px;
  height: 40px;
}

.header-current-weather {
  font-size: 1rem;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.header-current-weather img {
  width: 20px;
  height: 20px;
}

.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

form {
  position: relative;
  margin-left: auto;
  display: flex;
}

form::after {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  content: "";
  display: block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) center no-repeat;
  height: 20px;
  width: 20px;
}

input {
  border-radius: 10px;
  padding: 5px 10px 5px 40px;
  border: 2px solid var(--gray-400);
}

button {
  border: 0;
  padding: 0;
  background: none;
  cursor: pointer;
}

.unit-selector {
  position: relative;
  width: 70px;
}

.unit-selector .icon-button {
  position: relative;
  display: block;
  padding-right: 25px;
  font-weight: bold;
  margin: 0 auto;
}

.unit-selector .icon-button::after {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  content: "";
  display: block;
  background-position: center;
  background-repeat: no-repeat;
  height: 20px;
  width: 20px;
}

.unit-selector .icon-button.down::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.unit-selector .icon-button.up::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.unit-selector ul {
  list-style: none;
  position: absolute;
  display: none;
  gap: 10px;
  width: 70px;
  border-radius: 10px;
  border: 2px solid var(--gray-900);
  background-color: var(--white);
  padding: 10px;
}

.unit-selector button.active {
  border-bottom: 2px solid var(--gray-900);
}

/* Main */

main {
  display: flex;
  justify-content: center;
}

main .container {
  width: 960px;
  max-width: 100%;
  padding: 20px;
}

main .grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

section {
  border-radius: 10px;
  border: 2px solid var(--gray-400);
  background-color: var(--white);
}

section .top {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid var(--gray-400);
  padding: 10px;
}

section .bottom {
  padding: 10px;
  display: flex;
  gap: 10px;
}

section img {
  width: 80px;
  height: 80px;
}

section .desc {
  margin-bottom: 10px;
}

section ul {
  list-style: none;
  padding-left: 25px;
}

section li {
  position: relative;
}

section li::before {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -25px;
  content: "";
  background: center no-repeat;
  display: block;
  height: 20px;
  width: 20px;
}

section li.high::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

section li.low::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

section .temp {
  font-size: 4rem;
  line-height: 1;
  margin-bottom: 10px;
}

section .conditions {
  font-weight: bold;
}

/* Error */

.error {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,UAAU;;AAEV;EACE,6BAA6B;EAC7B;;0DAE+D;EAC/D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B;;0DAE4D;EAC5D,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;CAGC;;AAED;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,gBAAgB;;AAEhB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;;;;cAIY;EACZ,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,wBAAwB;;AAExB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,wCAAwC;;EAExC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,cAAc;EACd,oEAA6D;EAC7D,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,WAAW;EACX,cAAc;EACd,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yDAAwD;AAC1D;;AAEA;EACE,yDAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,iCAAiC;EACjC,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,SAAS;;AAET;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yDAAoD;AACtD;;AAEA;EACE,yDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,UAAU;;AAEV;EACE,aAAa;AACf","sourcesContent":["/* Fonts */\n\n@font-face {\n  font-family: \"Inclusive Sans\";\n  src:\n    url(\"assets/fonts/InclusiveSans-Regular.woff2\") format(\"woff2\"),\n    url(\"assets/fonts/InclusiveSans-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Inclusive Sans\";\n  src:\n    url(\"assets/fonts/InclusiveSans-Bold.woff2\") format(\"woff2\"),\n    url(\"assets/fonts/InclusiveSans-Bold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n/*\n  Josh's Custom CSS Reset\n  https://www.joshwcomeau.com/css/custom-css-reset/\n*/\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\np {\n  text-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n#root,\n#__next {\n  isolation: isolate;\n}\n\n/* Weather App */\n\n:root {\n  --gray-100: #f5f5f5;\n  --gray-400: #bdbdbd;\n  --gray-900: #212121;\n  --white: #fff;\n}\n\nbody {\n  font-family:\n    Inclusive Sans,\n    Arial,\n    Helvetica,\n    sans-serif;\n  color: var(--gray-900);\n  background-color: var(--gray-100);\n}\n\n/* Overlay and Spinner */\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 9999;\n  display: none;\n  justify-content: center;\n  align-items: center;\n  backdrop-filter: blur(5px);\n}\n\n.spinner {\n  width: 150px;\n  height: 150px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  padding: 20px;\n  background-color: var(--white);\n  border-radius: 10px;\n}\n\n.spinner-icon {\n  width: 50px;\n  height: 50px;\n  border: 5px solid var(--gray-100);\n  border-top: 5px solid var(--gray-400);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 10px;\n}\n\n.spinner-text {\n  font-weight: bold;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Header */\n\nheader {\n  display: flex;\n  justify-content: center;\n  background-color: var(--white);\n  border-bottom: 2px solid var(--gray-400);\n\n  width: 100%;\n}\n\nheader .container {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  width: 960px;\n  max-width: 100vw;\n  padding: 10px 20px;\n}\n\nh1 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  line-height: 1;\n}\n\nh1 img {\n  width: 40px;\n  height: 40px;\n}\n\n.header-current-weather {\n  font-size: 1rem;\n  text-transform: capitalize;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n}\n\n.header-current-weather img {\n  width: 20px;\n  height: 20px;\n}\n\n.visually-hidden {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\nform {\n  position: relative;\n  margin-left: auto;\n  display: flex;\n}\n\nform::after {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 10px;\n  content: \"\";\n  display: block;\n  background: url(\"./assets/icons/search.svg\") center no-repeat;\n  height: 20px;\n  width: 20px;\n}\n\ninput {\n  border-radius: 10px;\n  padding: 5px 10px 5px 40px;\n  border: 2px solid var(--gray-400);\n}\n\nbutton {\n  border: 0;\n  padding: 0;\n  background: none;\n  cursor: pointer;\n}\n\n.unit-selector {\n  position: relative;\n  width: 70px;\n}\n\n.unit-selector .icon-button {\n  position: relative;\n  display: block;\n  padding-right: 25px;\n  font-weight: bold;\n  margin: 0 auto;\n}\n\n.unit-selector .icon-button::after {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 0;\n  content: \"\";\n  display: block;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 20px;\n  width: 20px;\n}\n\n.unit-selector .icon-button.down::after {\n  background-image: url(\"./assets/icons/chevron-down.svg\");\n}\n\n.unit-selector .icon-button.up::after {\n  background-image: url(\"./assets/icons/chevron-up.svg\");\n}\n\n.unit-selector ul {\n  list-style: none;\n  position: absolute;\n  display: none;\n  gap: 10px;\n  width: 70px;\n  border-radius: 10px;\n  border: 2px solid var(--gray-900);\n  background-color: var(--white);\n  padding: 10px;\n}\n\n.unit-selector button.active {\n  border-bottom: 2px solid var(--gray-900);\n}\n\n/* Main */\n\nmain {\n  display: flex;\n  justify-content: center;\n}\n\nmain .container {\n  width: 960px;\n  max-width: 100%;\n  padding: 20px;\n}\n\nmain .grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\nsection {\n  border-radius: 10px;\n  border: 2px solid var(--gray-400);\n  background-color: var(--white);\n}\n\nsection .top {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 2px solid var(--gray-400);\n  padding: 10px;\n}\n\nsection .bottom {\n  padding: 10px;\n  display: flex;\n  gap: 10px;\n}\n\nsection img {\n  width: 80px;\n  height: 80px;\n}\n\nsection .desc {\n  margin-bottom: 10px;\n}\n\nsection ul {\n  list-style: none;\n  padding-left: 25px;\n}\n\nsection li {\n  position: relative;\n}\n\nsection li::before {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: -25px;\n  content: \"\";\n  background: center no-repeat;\n  display: block;\n  height: 20px;\n  width: 20px;\n}\n\nsection li.high::before {\n  background-image: url(\"./assets/icons/arrow-up.svg\");\n}\n\nsection li.low::before {\n  background-image: url(\"./assets/icons/arrow-down.svg\");\n}\n\nsection .temp {\n  font-size: 4rem;\n  line-height: 1;\n  margin-bottom: 10px;\n}\n\nsection .conditions {\n  font-weight: bold;\n}\n\n/* Error */\n\n.error {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
